import ContentCardBlock from "./ContentCardBlock";

export default ContentCardBlock;
